<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
    labels: {
      type: Array,
      required: true
    },
    datasets: {
      type: Array,
      required: true
    }
  },
  methods: {
    render () {
      if (this.$data._chart != null) {
        this.$data._chart.data.labels = this.labels
        this.$data._chart.data.datasets = this.datasets
        this.$data._chart.update()
      } else {
        this.renderChart({
          labels: this.labels,
          datasets: this.datasets
        }, {
          legend: {
            fullWidth: true
          },
          animation: {
            duration: 500,
            easing: 'linear'
          }
        })
      }
    }
  },
  mounted () {
    this.render()
  },
  watch: {
    labels: function (val) {
      this.render()
    },
    datasets: function (val) {
      this.render()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/charts/Bar.vue